exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2OaehApeAOw58U1GVNjCfA{padding:20px;border-radius:10px}.ZE_s1aLnNNFim5mzfm-d0{margin:20px}._9c5luVn5d2oPX6kAgVpNY{margin-right:10px}.kyT0pVWmEB0UI7ykBnRIL{margin-top:10px}._2r0tp3g3gnkZq4PzCOVpu0{position:absolute;top:20px;right:20px;opacity:0.8;cursor:pointer}._2r0tp3g3gnkZq4PzCOVpu0:hover{opacity:1}\n", ""]);

// Exports
exports.locals = {
	"content": "_2OaehApeAOw58U1GVNjCfA",
	"formField": "ZE_s1aLnNNFim5mzfm-d0",
	"fieldName": "_9c5luVn5d2oPX6kAgVpNY",
	"submitButton": "kyT0pVWmEB0UI7ykBnRIL",
	"closeButton": "_2r0tp3g3gnkZq4PzCOVpu0"
};